import { Box } from '@mui/material';
import '../../App.css';
import Add from '../../components/Add/Add';
import AppClose from '../../components/AppClose/AppClose';
import AppStart from '../../components/AppStart/AppStart';
import AuthForm from '../../components/AuthForm/AuthForm';
import { BackendSelector } from '../../components/BackendSelector/BackendSelector';
import Collections from '../../components/Collections/Collections';
import MusicFetch from '../../components/MusicFetch/MusicFetch';
import Share from '../../components/Share/Share';
import TrackContainer from '../../components/TrackPlayer/TrackContainer';
import { BasicPage } from '../../page-templates/BasicPage/BasicPage';
import { DemoAppContextProvider } from './DemoAppContext';

export function DemoApp() {
  return (
    <BasicPage>
      <DemoAppContextProvider>
        <AuthForm />
        <Box className="app-grid">
          <AppStart />
          <AppClose />
          <Share />
          <Add />
        </Box>
        <MusicFetch />
        <Collections />
        <TrackContainer />
        <BackendSelector />
      </DemoAppContextProvider>
    </BasicPage>
  );
}
